module.exports = __webpack_public_path__ + "static/media/tl_cardholderdelete.bdee34da.svg";